import { AnyAction } from '@reduxjs/toolkit';
import { GetCustomerLicensesRoutine } from '~modules/Companies/redux-routines';
import { AssignLicenseEditRoutine, RemoveLicenseFromCustomerRoutine } from '~modules/Licenses/redux-routines';
import type { TCustomersLicensesState } from '../interfaces';

export const initialState: TCustomersLicensesState = {
  data: [],
  error: null,
  isLoading: false,
};

export const customersLicensesReducer = (
  state: TCustomersLicensesState = initialState,
  action: AnyAction,
): TCustomersLicensesState => {
  switch (action.type) {
    case GetCustomerLicensesRoutine.REQUEST:
    case AssignLicenseEditRoutine.REQUEST:
    case RemoveLicenseFromCustomerRoutine.REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case GetCustomerLicensesRoutine.SUCCESS: {
      return {
        ...state,
        data: GetCustomerLicensesRoutine.getSuccessPayload(action),
        isLoading: false,
      };
    }
    case RemoveLicenseFromCustomerRoutine.SUCCESS: {
      const removedLicenseId = action.payload as number;
      return {
        ...state,
        data: state.data.filter((i) => i.licenseId !== removedLicenseId),
        isLoading: false,
      };
    }
    case GetCustomerLicensesRoutine.FAILURE:
    case AssignLicenseEditRoutine.FAILURE:
    case RemoveLicenseFromCustomerRoutine.FAILURE: {
      return {
        ...state,
        error: action.payload as Error,
        isLoading: false,
      };
    }
    default:
      return state;
  }
};
